import React, { useEffect } from "react";
import { ScrollTrigger } from "../animations/gsap.config";

import ServicesHero from "../components/services/ServicesHero";
import ServiceShowcase from "../components/services/ServiceShowcase";
import ServiceProcess from "../components/services/ServiceProcess";
import ServicesCTA from "../components/services/ServicesCTA";
import { useApp } from "../context/AppContext";
import SEO from "../components/SEO";

const Services = () => {
  /* Refresh ScrollTrigger after components mount */
  useEffect(() => {
    const timer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    return () => clearTimeout(timer);
  }, []);
  const { companyinfo } = useApp();
  return (
    <>
      <SEO
        title="Our Services | Comprehensive Solutions"
        description="Explore our core services: Formative Research, Monitoring & Evaluation (M&E), Independent Third-Party Monitoring (TPM), and Targeted Capacity Building across Ethiopia."
        keywords={[
          "Formative Research",
          "Third-Party Monitoring",
          "M&E services Ethiopia",
          "Capacity Building Training",
          "Baseline assessments",
        ]}
        url="https://agoraconsulting-et.com/services"
        image={`${companyinfo?.logo}`}
      />
      <main className="bg-white transition-colors duration-500">
        <ServicesHero />
        <ServiceShowcase />
        <ServiceProcess />
        <ServicesCTA />
      </main>
    </>
  );
};

export default Services;
